import { navigation } from './navigation.js';
import { AppSyncBase } from './app_sync_base.js';

/**
 * Sync for shared trips.
 */
class AppSyncTrip extends AppSyncBase {
  notifyChecklistChanged() {
    return this.send(this.messages.checklistUpdate);
  }

  notifyFoodMenuChanged() {
    return this.send(this.messages.foodMenuUpdate);
  }

  notifyCocampersChanged() {
    return this.send(this.messages.cocampersUpdate);
  }

  on({ id, type }) {
    let tripIdentifier = {
      id: parseInt(id),
    };
    switch (type) {
      case this.messages.connected:
        // Update the trip in case if it was changed after we loaded it but before
        // we received any updates from App server.
        this.onChecklistUpdate(tripIdentifier);
        break;

      case this.messages.checklistUpdate:
        this.onChecklistUpdate(tripIdentifier);
        break;

      case this.messages.cocampersUpdate:
        this.onCocampersUpdate(tripIdentifier);
        break;

      case this.messages.foodMenuUpdate:
        this.onFoodMenuUpdate(tripIdentifier);
        break;

      default:
        break;
    }
  }

  onChecklistUpdate(tripIdentifier) {
    navigation.tripPlanning.syncChecklist(tripIdentifier);
  }

  onCocampersUpdate(tripIdentifier) {
    navigation.tripPlanning.syncCocampers(tripIdentifier);
  }

  onFoodMenuUpdate(tripIdentifier) {
    navigation.tripPlanning.syncFoodMenu(tripIdentifier);
  }

  get messages() {
    if (!this.#messages) {
      this.#messages = Object.assign({}, super.messages, {
        checklistUpdate: 'checklist-update',
        cocampersUpdate: 'cocampers-update',
        foodMenuUpdate: 'food-menu-update',
      });
    }
    return this.#messages;
  }

  get pipeType() {
    return 'trip';
  }

  #messages;
}

export { AppSyncTrip };
